'use client';
import { Category, List, MarketplaceTag, PublicEducatorReview } from '@shared/types';
import { PublicEducator, PublicMembership } from '@cademy-package/sdk-component-types';
import { EducatorSecondaryLocation } from '../../../../pages_components/[educator_param]/getEducatorDetails';
import { EducatorProfile, EducatorProfileProps } from '../../../../components/EducatorProfile';
import { Vouchers } from '../../Vouchers';

export type VouchersProps<Pages extends string> = {
    educator: PublicEducator;
    memberships: PublicMembership[];
    vouchers_app_installed: boolean;
    lists: List[];
    internalReviewSummary: PublicEducatorReview[];
    secondary_locations: EducatorSecondaryLocation[];
    categories: Category[];
    marketplaceTags: MarketplaceTag[];
    hasMarketplacePublishedCourses: boolean;
    courseSlug?: string;
} & {
    pages: EducatorProfileProps<Pages>['tabs'];
    activeTabKey: EducatorProfileProps<Pages>['activeTabKey'];
};

export const EducatorVouchersPage = <Pages extends string>({
    educator,
    pages,
    activeTabKey,
    courseSlug,
}: VouchersProps<Pages>) => {
    return (
        <EducatorProfile educator={educator} tabs={pages} activeTabKey={activeTabKey}>
            <main>
                <Vouchers educator={educator} courseSlug={courseSlug} />
            </main>
        </EducatorProfile>
    );
};
